export var getColoringClassForTag = function (coloring) {
    return coloring ? "revisionColoringTag revisionColoringTag--" + coloring.toLowerCase() : '';
};
//# sourceMappingURL=tagChipColoringUtils.js.map